import React from 'react';

import BlogSeo from '../Blog/BlogSeo';

const extractPlainText = (richText) => {
  try {
    const parsed = JSON.parse(richText);

    const extractFromContent = (content) => {
      return content
        .map((node) => {
          if (node.nodeType === 'text') return node.value?.trim();
          if (node.content) return extractFromContent(node.content);
          return '';
        })
        .join(' ')
        .replace(/\s+/g, ' ')
        .replaceAll(' ,', ',')
        .trim();
    };

    return parsed.content
      .map((node) => extractFromContent(node.content || []))
      .join(' ')
      .replace(/\s+/g, ' ')
      .replaceAll(' ,', ',')
      .trim();
  } catch (error) {
    console.error('Error parsing rich text:', error);
    return '';
  }
};

const buildFaqSchema = (faqContent = []) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqContent.map((faq) => ({
    '@type': 'Question',
    name: faq.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.body?.raw ? extractPlainText(faq.body.raw) : extractPlainText(faq.supportingText?.raw),
    },
  })),
});

const BlogPostHead = ({ post, location }) => {
  const ogImage = post?.pageMetaData?.ogImage;
  const heroImage = post?.heroImage;

  const imageBackup = ogImage?.resize?.src || ogImage?.file?.url || heroImage?.file?.url || '';

  const imageAlt = ogImage?.description || heroImage?.description || ogImage?.title || heroImage?.title || '';

  const pageMeta = {
    ...post?.pageMetaData,
    ogImageUrl: imageBackup,
    ogImageAlt: imageAlt,
  };

  const faqContent = post?.faq?.content;
  const faqSchema = faqContent ? buildFaqSchema(faqContent) : null;

  const newsArticleSchema = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: post.title,
    image: imageBackup,
    datePublished: post.publishDate,
    author: post.author
      ? {
          '@type': 'Person',
          name: post.author.name,
          jobTitle: post.author.title,
        }
      : null,
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'blog',
        item: 'https://www.fullstory.com/blog/',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: post.title,
      },
    ],
  };

  return (
    <>
      <BlogSeo meta={pageMeta} slug={location.pathname} />
      <meta name="zd-site-verification" content={process.env.GATSBY_ZENDESK_CRAWLER_KEY} />

      <script type="application/ld+json">{JSON.stringify(newsArticleSchema)}</script>

      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>

      {faqSchema && <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>}
    </>
  );
};

export default BlogPostHead;
